import { Row, Col, Typography, Image, ConfigProvider, Button } from "antd";
// import PresentImage from "../../../../assets/images/yen-d/header.png";
import PresentImage from "../../../../assets/images/hse/hsexosd_logo.png";

import { useParams } from "react-router";
import { ArrowRightOutlined } from "@ant-design/icons";
export interface Props {
  onChangeData: (dataField: any, newdataField: any) => void;
  onChangeCurrentStep: (step: number) => void;
  currentStep: number;
}

export const EconnectStepOne: React.FC<Props> = ({
  onChangeData,
  onChangeCurrentStep,
  currentStep,
}) => {
  const { agendaid, typeregis, customerid } = useParams<{
    agendaid: string;
    typeregis: string;
    customerid: string;
  }>();
  return (
    <>
      <div
        className="sm:w-full md:w-[600px] md:h-[653.18px] top-[99px] left-[25px] rounded-[10px] pt-[32px] px-[26px] pb-[32px]   mt-10 
      gap-[32px] flex flex-col items-center text-center"
      >
        {/* <div className="w-[301px] h-[77.87px] gap-[10px] pb-4">
          <Image src={Logo} preview={false} />
        </div> */}

        <div className="  mb-4">
          <Image
            src={PresentImage}
            preview={false}
            className="w-full"
            width={"70%"}
            // style={{ marginTop: -40 }}
          />
        </div>
        <div className="w-full   flex flex-col items-center text-center">
          <div>
            {/* Top small text */}

            {/* Big WELCOME */}
            <h1 className="mt-2 text-[70px] md:text-[96px] font-extrabold text-blue-900 leading-none tracking-tight ">
              WELCOME
            </h1>
            <div className="w-full max-w-[600px] text-center">
              <div
                className="text-[#ffde59] font-semibold tracking-[0.25em] md:tracking-[0.4em]
      drop-shadow-[0_0_8px_rgba(255,216,77,0.6)]"
              >
                Sasin Business School Delegation
              </div>
            </div>

            {/* Date */}
            <div>
              <div className="mt-6 inline-block px-4 py-1 rounded-full border border-white/40 bg-black/30 backdrop-blur-md">
                <span className="text-white text-sm md:text-xl tracking-[0.3em] font-semibold">
                  Wednesday, 6 May 2026
                </span>
              </div>
            </div>

            <p
              className="mt-2 text-white text-lg font-medium 
  drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]"
            >
              13:00 PM – 17:00 PM
            </p>

            <p
              className="mt-1 text-white text-sm 
  drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]"
            >
              Alpha Meeting Room, 4th Floor, OSD
            </p>
          </div>
        </div>

        <ConfigProvider
          theme={{
            token: { colorPrimary: "#160C65" },
          }}
        >
          <Button
            type="primary"
            className="w-full  mt-10 h-[58px] rounded-[5px] border-2 px-[45px] py-[13px] gap-8  "
            // style={{ top: -37 }}
            onClick={() => {
              onChangeCurrentStep(currentStep + 1);
            }}
          >
            <h2 className="font-manrope font-bold text-[20px] leading-[32px] tracking-[0px] text-center text-[rgba(255,255,255,1)]">
              Register <ArrowRightOutlined />
            </h2>
          </Button>
        </ConfigProvider>
      </div>
    </>
  );
};
